var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 167.69",
    id: 1550211753,
    className: "svg u_1550211753",
    "data-icon-custom": "true",
    "data-icon-name": "MISION.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-1908030729{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003F71",
    d: "M143.45,65.1A101.35,101.35,0,0,1,75,161,101.35,101.35,0,0,1,6.55,65.1V24.61A154.94,154.94,0,0,0,75,7a154.94,154.94,0,0,0,68.45,17.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003F71",
    className: "cls-1-1908030729",
    d: "M73.62,21.54A166.92,166.92,0,0,1,21.9,36,3.28,3.28,0,0,0,19,39.3V65.1a88.9,88.9,0,0,0,54.75,82.08,3.25,3.25,0,0,0,2.5,0A88.9,88.9,0,0,0,131,65.1V39.3A3.28,3.28,0,0,0,128.1,36a166.92,166.92,0,0,1-51.72-14.5,3.32,3.32,0,0,0-2.76,0ZM124.45,42.2V65.1A82.39,82.39,0,0,1,75,140.6,82.39,82.39,0,0,1,25.55,65.1V42.2A173.55,173.55,0,0,0,75,28.12,173.55,173.55,0,0,0,124.45,42.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003F71",
    d: "M124.45,42.2V65.1A82.39,82.39,0,0,1,75,140.6,82.39,82.39,0,0,1,25.55,65.1V42.2A173.55,173.55,0,0,0,75,28.12,173.55,173.55,0,0,0,124.45,42.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003F71",
    d: "M146.72,18.1A148.34,148.34,0,0,1,76.55.39a3.28,3.28,0,0,0-3.1,0A148.34,148.34,0,0,1,3.28,18.1,3.28,3.28,0,0,0,0,21.37V65.1A107.9,107.9,0,0,0,74,167.52a3.21,3.21,0,0,0,2.06,0A107.9,107.9,0,0,0,150,65.1V21.37a3.28,3.28,0,0,0-3.28-3.27Zm-3.27,47A101.35,101.35,0,0,1,75,161,101.35,101.35,0,0,1,6.55,65.1V24.61A154.94,154.94,0,0,0,75,7a154.94,154.94,0,0,0,68.45,17.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003F71",
    className: "cls-1-1908030729",
    d: "M75,45a3.27,3.27,0,0,0-2.93,1.83L63,65.24l-20.34,3a3.28,3.28,0,0,0-1.81,5.59L55.53,88.14,52.06,108.4a3.27,3.27,0,0,0,1.31,3.2,3.22,3.22,0,0,0,1.92.63,3.33,3.33,0,0,0,1.53-.38L75,102.28l18.2,9.56A3.27,3.27,0,0,0,98,108.39L94.48,88.13l14.71-14.36a3.27,3.27,0,0,0-1.81-5.58L87,65.24,77.93,46.8A3.28,3.28,0,0,0,75,45Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.915f441b70af3cae339ad9c3d17d8891.svg";
export { ForwardRef as ReactComponent };